module.exports = __webpack_public_path__ + "static/media/quoteDoctor1.d849b59f.jpg";